<template>
	<div>
		<md-content>
			<div class="md-layout md-gutter">
		       <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>请输入APPID/ID/产品名称</label>
				      <md-input v-model="pdata.kw"></md-input>
				    </md-field>
		       </div>
		    </div> 
		    <md-content>
			    <md-table  v-if="plist.length>0">
			      <md-table-row>
			        <md-table-head>广告投放名称</md-table-head>
			        <md-table-head>投放的广告位数量</md-table-head>
			        <md-table-head>投放的创意数量</md-table-head>
			        <md-table-head>启用时间</md-table-head>
			        <md-table-head>禁用时间</md-table-head>
			        <md-table-head>投放状态</md-table-head>


			      </md-table-row>

			      <md-table-row v-for="item,index in plist">
			        <md-table-cell>{{item.name}}</md-table-cell>
			        <md-table-cell>{{item.space_num}}</md-table-cell>
			        <md-table-cell>{{item.creative_num}}</md-table-cell>
			        <md-table-cell>{{item.start_time}}</md-table-cell>
			        <md-table-cell>{{item.end_time}}</md-table-cell>
			        <md-table-cell>{{item.status=='1'?'正常':'禁用'}}</md-table-cell>
			
			      </md-table-row>
				</md-table>
			    
			    <md-table  v-else>
			      <md-table-row>
			        <md-table-head>暂无信息</md-table-head>
			      </md-table-row>
				</md-table>
				
				<div class="md-layout md-gutter md-alignment-center">
				    <div class="md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25">
				    	 <md-button class="md-dense md-primary" @click.native="goPrev">上一页</md-button>
				    </div>
				    <div class="md-layout-item md-medium-size-80 md-small-size-50 md-xsmall-size-50">
				    	 <md-field>
				          <label >选择页码</label>
				          <md-select v-model="pdata.page" name="page" id="page">
				            <md-option :value="item" v-for="item in maxPage">{{item}}</md-option>
				          </md-select>
				        </md-field>
				    </div>
				    <div class="md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25">
				    	 <md-button class="md-dense md-primary" @click.native="goNext">下一页</md-button>
				    </div>
			 	 </div>
			 </md-content>

		    
		    
		</md-content>
	</div>
</template>

<script>
	import { sconfig,sadtou, saddp, spstatus, splog, seditp, scopy } from "../api/api";
	export default {
		 data() {
		 	return{
		 		pdata: {
			        page: 1,
			        perpage: 10,
			        theme: "",
			        status: "",
			        kw: "",
			        sort_field: "",
			        sort_by: "",
			        placement:""
			      },
			      maxPage:1,
			      plist: [],
			      pText:"请选择产品投放位置",
			      option: [] //投放位置配置
			 	}
		 	  
		 },
		   watch: {
		    "pdata.placement": {
		      handler(n, o) {
		        this.pdata.placement=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.kw": {
		      handler(n, o) {
		        this.pdata.kw=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.page": {
		      handler(n, o) {
		        this.pdata.page=n;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    }
		  },
		 methods:{
		 	goDetail(id){
		 		this.$router.push({ path: '/product/detail/'+id })
		 	},
		 	getList() {
		      var p = "";
		      for (var k in this.pdata) {
		        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
		        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
		      }
		      sadtou(p, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.plist = res.data.list;
		          this.maxPage = res.data.max_page;
		        }
		      });
		    },
			getConfig() {
		      if (this.$store.config) {
		        this.config = this.$store.config.product_theme;
		        this.tags = this.$store.config.product_tag;
		        this.option = this.$store.config.product_placement;
		      } else {
		        setTimeout(() => {
		          this.getConfig();
		        }, 50);
		      }
		    },
		    clearPlacement(s){
		    	this.pdata.placement = '';
		    },
		    goPrev(){
		    	
		    	if(this.pdata.page>1){
		    		this.pdata.page--;
		    	}
		    	
		    },
		    goNext(){
		    	if(this.pdata.page<this.maxPage){
		    		this.pdata.page++;
		    	}
		    	
		    }
		 },
		 mounted() {

		    this.getConfig();
		    this.getList();
		 }
		 
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ADdelivery.vue?dfd5ff00